import React, { useState } from "react";
import requestAnimated from "../../assets/img/request/callback_animated.png";
import requestRightBg from "../../assets/img/request/callback_bg.png";

const stages = [
  "Just starting",
  "Under 2 years",
  "Established, books are behind",
  "Established, want a new bookkeeper",
];

export const ContactRequestArea = () => {
  const [submittedName, setSubmittedName] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const name = new FormData(form).get("name");
    setSubmittedName(String(name || "").trim());
  };

  return (
    <section className="request-area-two" id="contact-form">
      <div
        className="request-shape-right"
        data-aos="fade-left"
        data-aos-delay="200"
        style={{ backgroundImage: `url(${requestRightBg})` }}
      ></div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="request-content-two">
              <div className="section-title-two white-title mb-15 tg-heading-subheading animation-style3">
                <h2 className="title tg-element-title">
                  Get Your Free Books Health Check
                </h2>
              </div>
              <p>
                Tell us a little about your business and we'll call you within
                one business day. No obligation.
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="request-form-wrap">
              {submittedName ? (
                <div className="request-form-success">
                  <h3 className="title">Request received</h3>
                  <p>
                    Thanks, {submittedName.split(" ")[0]}. We will call you
                    within one business day.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate={false}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-grp">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name *"
                          aria-label="Name"
                          autoComplete="name"
                          required
                          minLength={2}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-grp">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email *"
                          aria-label="Email"
                          autoComplete="email"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-grp">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone *"
                          aria-label="Phone"
                          autoComplete="tel"
                          required
                          minLength={10}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-grp">
                        <select
                          name="stage"
                          aria-label="Business stage"
                          defaultValue=""
                          required
                        >
                          <option value="" disabled>
                            Business stage *
                          </option>
                          {stages.map((stage) => (
                            <option key={stage} value={stage}>
                              {stage}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-12">
                      <button type="submit">Request My Free Call</button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="request-shape-wrap">
        <img src={requestAnimated} alt="" />
      </div>
    </section>
  );
};
